import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Field, reduxForm } from 'redux-form'
import TextField from 'material-ui/TextField'
import { withStyles } from 'material-ui/styles'
import { RichUtils } from 'draft-js'
import Editor from 'draft-js-plugins-editor'
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin'
import 'draft-js-inline-toolbar-plugin/lib/plugin.css'
import { ToolbarButton } from './Toolbar'
import SaveIcon from 'material-ui-icons/Save'

const inlineToolbarPlugin = createInlineToolbarPlugin()
const { InlineToolbar } = inlineToolbarPlugin

const renderNoteTitleField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    style={{ fontSize: 'large' }}
    label={label}
    {...input}
    {...custom}
  />
)

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  field: {
    marginBottom: 2 * theme.spacing.unit
  },
  saveButton: {
    alignSelf: 'center'
  },
  noteTitle: {
    fontSize: 'x-large',
    height: 'auto'
  }
})

class NoteForm extends Component {
  constructor(props) {
    super(props)
    this.toolbarElement = document.createElement('span')
    this.toolbarRoot = ReactDOM.findDOMNode(props.toolbar)
  }
  componentDidMount() {
    this.toolbarRoot.appendChild(this.toolbarElement)
  }
  componentWillUnmount() {
    this.toolbarRoot.removeChild(this.toolbarElement)
  }
  handleKeyCommand(command) {
    const { editorState, onEditorChange } = this.props
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      onEditorChange(newState)
      return 'handled'
    }
    return 'not-handled'
  }
  render() {
    const {
      classes,
      handleSubmit,
      submitting,
      editorState,
      onEditorChange
    } = this.props
    return (
      <form
        ref={el => (this.form = el)}
        onSubmit={handleSubmit}
        className={classes.form}
      >
        {ReactDOM.createPortal(
          <ToolbarButton
            onClick={event => handleSubmit(event)}
            icon
            floatRight
            color="primary"
            type="submit"
            disabled={submitting}
          >
            <SaveIcon />
          </ToolbarButton>,
          this.toolbarElement
        )}
        <Field
          name="title"
          type="text"
          component={renderNoteTitleField}
          placeholder="Note title"
          className={classes.field}
          inputClassName={classes.noteTitle}
        />
        <div onClick={() => this.editor.focus()}>
          <Editor
            editorState={editorState}
            handleKeyCommand={command => this.handleKeyCommand(command)}
            onChange={onEditorChange}
            plugins={[inlineToolbarPlugin]}
            placeholder="Note content"
            ref={element => {
              this.editor = element
            }}
          />
          <InlineToolbar />
        </div>
      </form>
    )
  }
}

export default reduxForm({ form: 'note' })(withStyles(styles)(NoteForm))



// WEBPACK FOOTER //
// ./src/components/NoteForm.js